export default {
  body: document.querySelector('body'),
  toggle: document.querySelector('.theme-switch-toggle'),
  prevRef: document.querySelector('.prev'),
  nextRef: document.querySelector('.next'),
  errorInpRef: document.querySelector('#error'),
  searchInpRef: document.querySelector('#search-input'),
  loaderRef: document.querySelector('.loader'),
  moviesListRef: document.querySelector('.movies-list'),
  pageNumsRef: document.querySelector('.page-numbers'),
  watchedBtnRef: document.querySelector('#watched'),
  queueBtnRef: document.querySelector('#queue'),
};

